import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-icustomer-limit-error',
  templateUrl: './icustomer-limit-error.component.html',
  styleUrls: ['./icustomer-limit-error.component.scss']
})
export class IcustomerLimitErrorComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<IcustomerLimitErrorComponent>) { 
    this.closeBox()
  }

  closeBox() {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
